export enum PageUrl {
  home = "/home",
  test = "/test",
  cardDemo = "/card-demo",
  tableDemo = "/table-demo",
  customTableDemo = "/custom-table-demo",
  mformDemo = "mform-demo",
  classifiers = "/classifiers",
  docs = "/docs",
  managementCatalogs = "/management/catalogs",
  managementCatalogNew = "/management/catalog/new",
  managementCatalogEdit = "/management/catalog/:id",
  managementCatalogAccess = "/management/catalog/access/:id",
  managementClassifiers = "/management/classifiers",
  managementClassifierCard = "/management/classifiers/:id",
  managementClassifierAccess = "/management/classifiers/access/:id",
  managementPrimSpecs = "/management/prim-specs",
  managementPrimSpecCard = "/management/prim-specs/:id",
  managementUsers = "/management/users",
  managementUserEdit = "/management/users/:id",
  managementUserNew = "/management/users/new",
  managementRoles = "/management/roles",
  managementRoleEdit = "/management/roles/:id",
  managementRoleNew = "/management/roles/new",
  managementSecondSpecs = "/management/second-specs",
  managementSecondSpecCard = "/management/second-specs/:id",
  managementValueSpecs = "/management/value-specs",
  managementValueSpecCard = "/management/value-specs/:id",
  managementValueCatalogs = "/management/value-catalogs",
  managementValueCatalogNew = "/management/value-catalog/new",
  managementValueCatalogEdit = "/management/value-catalog/:id",
  managementWorkflows = "/management/workflows",
  managementWorkflowNew = "/management/workflow/new",
  managementWorkflowCard = "/management/workflow/:id",
  managementExtensions = "/management/extensions",
  managementExtensionNew = "/management/extensions/new",
  managementExtensionCard = "/management/extensions/:id",
  valueCatalog = "/value-catalog/:id",
  valueCatalogNew = "/value-catalog/new/:id", // id = valueCatalogId
  valueCatalogEdit = "/value-catalog/card/:id", // id => value catalog card
  classes = "/classes/:id",
  newClass = "/class/new/:id", // id=>classifier, search.classId?=>parent class
  class = "/class/:id",
  // classSpecs = "/class-specs/:id", // id=classId
  workflowStreams = "/workflow-streams",
  workflowCards = "/workflow-streams/:id",
  catalogs = "/catalogs",
  records = "/records/:id", // id=catalog
  newRecord = "/record/new/:id", // id=catalogId
  editRecord = "/record/:id", // id=recordId
  recordHistory = "/record-history/:id", // id=recordId
  newRecordWf = "/record/new/:id/workflow/:workflowId", // id=catalogId
  editRecordWf = "/record/:id/workflow", // id=recordId
}
